import { useCallback, useEffect, useState } from "react";
import { gxlookupApi } from "../apiConfig/services/authAbstractApiLayer";

export interface ContactSupportItem {
  gxLookupId: number;
  gxLookupType: string;
  gxLookupCode: string;
  gxLookupValue: string;
  gxLookupDesc: string | null;
  gxLookupSeq: number;
  menuId: number;
  permissionId: number;
}

interface UseContactSupportLookupResult {
  data: ContactSupportItem[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useContactSupportLookup = (): UseContactSupportLookupResult => {
  const [data, setData] = useState<ContactSupportItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSupportList = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const payload = { gxLookupType: "CONTACT_SUPPORT" };
      const result = await gxlookupApi(payload);
      const list: ContactSupportItem[] = Array.isArray(result)
        ? result
        : result?.data ?? [];

      setData(list);
    } catch (err) {
      console.error(err, "gxsmeuserLookupsApi error");
      setError("Unable to load support details. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSupportList();
  }, [fetchSupportList]);

  return { data, loading, error, refetch: fetchSupportList };
};